import { render, staticRenderFns } from "./TemplateImport.vue?vue&type=template&id=45394b2b&scoped=true"
import script from "./TemplateImport.vue?vue&type=script&lang=js"
export * from "./TemplateImport.vue?vue&type=script&lang=js"
import style0 from "./TemplateImport.vue?vue&type=style&index=0&id=45394b2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45394b2b",
  null
  
)

export default component.exports